export default __webpack_public_path__ + "static/media/portfolio-09.581fb6ec.jpg";